<template>
  <el-tabs type="border-card" stretch>
    <el-tab-pane label="涨幅榜">
      <el-table
        :data="gainsData"
        stripe
        size="mini"
        height="600px"
      >
        <el-table-column
          min-width="70px"
          prop="name"
          label="名称">
          <template slot-scope="scope">
            <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol,isIndex:false,direction:0}}" class="stockLinkColor">
              <span >{{ scope.row.name }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          label="涨跌幅"
          align="right">
          <template slot-scope="scope">
<!--            <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>-->
<!--            <span class="red" v-else>{{ scope.row.changepercent }}%</span>-->
            <span class="text_red_color" >{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="最近">
      <el-table
        :data="tableData"
        stripe
        size="mini"
        height="600px"
        >
        <el-table-column
          min-width="70px"
          prop="symbolName"
          label="名称">
          <template slot-scope="scope">
            <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol,isIndex:false,direction:0}}" class="stockLinkColor">
              <span >{{ scope.row.symbolName }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          label="涨跌幅"
          align="right">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>
            <span class="text_red_color" v-else>{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="自选">
      <div  v-show="$store.state.loginType">
        <el-table
          :data="concernData"
          stripe
          size="mini"
          height="600px"
        >
          <el-table-column
            prop="symbolName"
            label="名称">
            <template slot-scope="scope">
              <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol,isIndex:false,direction:0}}" class="stockLinkColor">
                <span >{{ scope.row.symbolName }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="trade"
            label="价格"
            align="center">
          </el-table-column>
          <el-table-column
            prop="changepercent"
            label="涨跌幅"
            align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>
              <span class="text_red_color" v-else>{{ scope.row.changepercent }}%</span>
              <el-button size="mini" type="text" icon="el-icon-circle-close" @click="cancel_concern(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="center" v-show="!$store.state.loginType" style="height: 600px">
        <router-link to="/login">
          <el-button type="button"  style="background-color:#0D268D;color:white;">请登录</el-button>
        </router-link>
      </div>
    </el-tab-pane>
    <el-tab-pane label="指数交易">
      <el-table
        :data="indexList"
        stripe
        size="mini"
        height="600px"
        >
        <el-table-column
          min-width="70px"
          prop="symbolName"
          label="名称">
          <template slot-scope="scope">
            <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.code,isIndex:true,direction:0}}" class="stockLinkColor">
              <span >{{ scope.row.name }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="price"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="inrease"
          label="涨跌幅"
          align="right">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.inrease.substr(0,1) === '-'">{{ scope.row.inrease }}%</span>
            <span class="text_red_color" v-else>{{ scope.row.inrease }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import eventBus from "../assets/js/eventBus";
  import $ from "jquery";
    export default {
      name: "stockcard",
      data() {
        return {
          // tableData: this.$store.state.stockVisited,
          concernData:[],
          gainsData:[],
          indexList: [],
          indexCodes: ["sh000001", "sz399001", "bj899050","sz399006","sh000680","sh000300"],
        }
      },
      computed: {
        tableData: function () {
          return this.$store.state.stockVisited
        },
      },
      methods:{
        fetchIndexData() {
          const that = this;
          $.ajax({
            url:
              "https://sqt.gtimg.cn/utf8/?q=" +
              that.indexCodes.toString() +
              "&_=" +
              new Date().getTime(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function () {
              let i, elements;
              const array = [];
              for (i = 0; i < that.indexCodes.length; i++) {
                try {
                  elements = eval("v_" + that.indexCodes[i]).split("~");
                } catch (e) {
                  continue;
                }
                const item = {
                  price: elements[3],
                  inrease: elements[32],
                  num: elements[31],
                  name: elements[1],
                  id: elements[0],
                  code: that.indexCodes[i],
                  relatedStockName: null,
                  relatedStockChange: null,
                };
                array.push(item);
              }
              that.indexList = array;
            },
            error: function () {
            },
          });
        },
        getCardInfo(){
          let that = this;
          let stockVisited = that.tableData;
          that.chatTimer = setInterval(function() {
            that.getStockInfo(stockVisited)
            that.fetchIndexData()
          }, 1000);
        },
        getStockInfo(stockVisited){
          let that = this;
          if (stockVisited.length === 0) return;
          const codes = [];
          for (let i = 0, len = stockVisited.length; i < len; i++) {
            const s = stockVisited[i].symbol;
            if (s != null && String(s).trim() !== "") {
              codes.push(String(s).trim());
            }
          }
          if (codes.length === 0) return;
          that.getNewPrice(codes, stockVisited);
        },
        getNewPrice(codes, dataArr) {
          let that = this;
          const q = [...new Set(codes)].join(",");
          if (!q) return;
          $.ajax({
            url: "https://qt.gtimg.cn/q=" + q,
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              for (let i = 0; i < dataArr.length; i++) {
                const code = dataArr[i].symbol;
                if (code == null || String(code).trim() === "") continue;
                const key = "v_" + String(code).trim();
                const raw = window[key];
                if (typeof raw !== "string") continue;
                const elements = raw.split("~");
                if (elements.length < 33) continue;
                dataArr[i].trade = elements[3];
                dataArr[i].changepercent = elements[32];
              }
              that.$store.commit("changeStocksVisited", dataArr);
            }
          });
        },
        getUserConcern(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'concern',
              token: sessionStorage.getItem("token")
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.getUserConcernInfo(resData.data);
              }
            });
        },
        //获取自选股票详细数据
        getUserConcernInfo(Concern){
          let that = this;
          if (Concern.length !== 0){
            let symbol = '';
            for (let i = 0, len = Concern.length; i < len; i++){
              symbol = symbol + 's_' + Concern[i].short + ',';
            }
            that
              .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'stockdetail',
                'symbol': symbol
              }
            })
              .then(ret => {
                let resData = ret.data;
                if (resData.code === 1){
                  let result = [];
                  for (let i = 0, len = resData.data.length; i < len; i+=10){
                    result.push(resData.data.slice(i,i+10));
                  }
                  result.pop();
                  let temp = [];
                  for (let i = 0, len = Concern.length; i < len; i++){
                    temp[i] = {symbol:Concern[i].short,code:Concern[i].code,symbolName:Concern[i].name,trade:result[i][3],changepercent:result[i][5]};
                  }
                  that.concernData = temp;
                }
              });
          }else{
            let temp = [];
            that.concernData = temp;
          }
        },
        getGainsData(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stockchange',
              'page': 1,
              'asc': 0,
              'num':15
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
              that.gainsData = resData.data;
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableData()
              })
            }
          });
        },
        cancel_concern(row){
          let that = this;
          that
            .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'cancel_concern',
                'token': window.sessionStorage.getItem('token'),
                'code': row.code
              }
            })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                this.$message({
                  message: resData.msg,
                  type: 'success',
                  onClose:function () {
                    that.getUserConcern();
                  }
                });
              }else{
                that.$message.error(resData.msg);
              }
            });
        }
      },
      created(){
        let that = this;
        eventBus.$on('concern',()=>{
          that.getUserConcern();
        });
      },
      mounted:function () {
        let that = this;
        this.getCardInfo();
        if (that.$store.state.loginType){
          this.getUserConcern();
        }
        this.getGainsData();
        this.fetchIndexData();
      },
      beforeDestroy() {
        clearTimeout(this.chatTimer);
      }
    }
</script>

<style scoped>
  .green{
    color: #3F7A21;
  }
  .stockLinkColor{
    color: #0D268D;
  }
  .stockLinkColor :hover{
    color: #0D268D;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockcard.vue